export const VTO_BEST_SHADE_HEX_VALUE = 'vto-best-shade-hex-value';
export const VTO_BEST_SHADE_NAME = 'vto-best-shade-name';
export const VTO_DISCLOSE_PARAM = 'vto_disclose';
export const VTO_FOUNDATION = 'Foundation';
export const VTO_FOUNDATION_OVERLAY_CLOSE = 'vto-foundation-overlay-close';
export const VTO_FOUNDATION_START_NOW_BUTTON = 'vto-foundation-start-now-button';
